import FormField from '@cloudscape-design/components/form-field'
import Select from '@cloudscape-design/components/select'
import Input from '@cloudscape-design/components/input'
import SpaceBetween from '@cloudscape-design/components/space-between'

const GOAL_TYPES = [
  { label: 'Grow referral volume from healthcare providers', value: 'grow_referrals' },
  { label: 'Increase social media engagement', value: 'increase_engagement' },
  { label: 'Expand provider network (new specialties)', value: 'expand_provider_network' },
  { label: 'Launch a new service or product line', value: 'launch_service' },
]

interface Props {
  goalType: string
  targetValue: string
  onGoalTypeChange: (v: string) => void
  onTargetValueChange: (v: string) => void
}

export function StepGoal({ goalType, targetValue, onGoalTypeChange, onTargetValueChange }: Props) {
  return (
    <SpaceBetween size="m">
      <FormField label="What is your primary marketing goal?" stretch>
        <Select
          selectedOption={GOAL_TYPES.find(o => o.value === goalType) ?? null}
          onChange={e => onGoalTypeChange(e.detail.selectedOption.value ?? '')}
          options={GOAL_TYPES}
          placeholder="Select a goal"
        />
      </FormField>
      <FormField label="Target number (e.g. 10 new referrals per month)" stretch>
        <Input
          value={targetValue}
          onChange={e => onTargetValueChange(e.detail.value)}
          type="number"
          placeholder="10"
        />
      </FormField>
    </SpaceBetween>
  )
}
